// src/admin/screens/loans/tabs/DocumentsTab.tsx
// Placeholder. Loan agreement PDFs land here when sub-project B wires
// document generation; KYC photos render on the borrower detail screen.
import { FileText } from 'lucide-react';
import EmptyState from '@admin/components/EmptyState';
import SectionHead from '@admin/components/SectionHead';
import type { LoanDetail } from '@admin/hooks/useLoan';

export default function DocumentsTab(_: { loan: LoanDetail }) {
  void _;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <SectionHead
        eyebrow="Records"
        title="Documents"
        description="Loan agreements and supporting files"
      />
      <EmptyState
        icon={<FileText size={26} strokeWidth={1.7} />}
        title="No loan documents yet"
        body="The signed loan agreement will appear here once sub-project B wires document generation. KYC photos live on the borrower detail screen."
      />
    </div>
  );
}
